/* eslint-disable react/jsx-props-no-spreading */
import React, { ReactElement, HTMLAttributes } from 'react';
import Loading from './Loading';
import './scroll.css';

interface Props extends HTMLAttributes<HTMLElement> {
  className?: string;
  height?: number | string;
  width?: number | string;
  children: ReactElement | ReactElement[];
  loading?: boolean;
}

const Scroll: React.FC<Props> = ({
  className, height, width, children, loading, ...props
}): ReactElement => (
  <div
    className={`scrollbar ${className}`}
    id="scroll-component"
    style={{ height, width, paddingRight: 10 }}
    data-scroll="true"
    {...props}
  >
    {loading ? <Loading /> : children}
  </div>
);

Scroll.defaultProps = {
  className: undefined,
  loading: false,
  height: undefined,
  width: undefined,
};

export default Scroll;
